export default __webpack_public_path__ + "static/media/cleanproReload2.c2695ee3.png";